jQuery(document).ready(function ($) {
	// Addons active state
	$('body').on('click', '.addon input', function () {
		$(this).closest('label').toggleClass('active');
	});

	$('body').on('click', '.addon a', function (e) {
		e.preventDefault();
		const varID = $(this).attr('data-id');
		UpsellAddNew(varID);
	});
});

// ATC Upsells
function UpsellAddNew(variantId, quantity = 1) {
	return fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify({
			id: variantId, // variant ID for the new product
			quantity: quantity,
		}),
	})
		.then((response) => {
			if (!response.ok)
				throw new Error(`Shopify returned ${response.status}`);
			return response.json();
		})
		.then(() => {
			// After adding, fetch the updated cart
			return fetch('/cart.js')
				.then((res) => res.json())
				.then((cart) => {
					console.log(cart);
					updateMiniCart(cart);
				});
		})
		.catch((error) => {
			console.error('Add to cart failed:', error);
			const errorBox = document.querySelector('.minicart-error');
			if (errorBox) {
				errorBox.textContent = '⚠️ Could not add product to cart.';
				errorBox.style.display = 'block';
			}
		});
}
